import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth uses httpOnly cookies (set by backend on login/register) with
// `withCredentials: true`. No token is stored in JavaScript-accessible
// storage, so tokens are safe from XSS.
const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err.message || "Bir hata oluştu";
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((e) => e?.msg || JSON.stringify(e)).join(", ");
  if (d?.msg) return d.msg;
  return String(d);
}

export function formatMoney(amount, currency = "TRY") {
  const symbol = currency === "TRY" ? "₺" : currency === "USD" ? "$" : "€";
  const num = Number(amount || 0);
  return `${symbol}${num.toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function formatDate(iso) {
  if (!iso) return "-";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("tr-TR", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return "-";
  }
}

export const VADE_LABELS = {
  nakit: "Nakit / Peşin",
  "15": "15 Gün",
  "30": "30 Gün",
  "60": "60 Gün",
  "90": "90 Gün",
  "120": "120 Gün",
};
